import React from 'react'
import {Dependencies} from './'

export const FeatureServicesContext = React.createContext<
    Dependencies | undefined
>(undefined)

export function useFeatureServices(): Dependencies {
    const featureServices = React.useContext(FeatureServicesContext)

    if (!featureServices) {
        throw new Error('No featureServices context value was provided.')
    }

    return featureServices
}
